import {
  Dropdown,
  IconButton,
  Icons,
  Tooltip,
  type DropdownMenuItemProps,
} from '@commenda/kakashi';
import { ChatProps } from '../../ChatRoom/types';

const ChatHeaderBackButton = ({ onBack }: { onBack: () => void }) => {
  return (
    <Tooltip side="bottom" content="See chat list">
      <IconButton
        icon={<Icons.ChevronLeft />}
        onClick={onBack}
        aria-label="See chat list"
        size="sm"
        className="!h-6"
      />
    </Tooltip>
  );
};

const ChatHeader = ({
  onBack,
  title,
  goToConnectedFilling,
}: {
  onBack?: () => void;
  title: string;
  goToConnectedFilling?: ChatProps['goToConnectedFilling'];
}) => {
  const items: DropdownMenuItemProps[] = goToConnectedFilling
    ? [
        {
          label: 'Go to filing',
          onClick: goToConnectedFilling,
          icon: Icons.CornerUpRight,
        },
      ]
    : [];

  return (
    <div className="bg-bg-secondary flex items-center justify-between gap-md w-full py-lg px-xl rounded-t-md">
      <div className="flex items-center gap-md w-full">
        <div className="flex items-center">
          {onBack && <ChatHeaderBackButton onBack={onBack} />}
        </div>
        <div className="txt-small-bold text-text-tertiary">
          {title ?? 'Start a new chat'}
        </div>
      </div>
      {title && items.length > 0 && (
        <Dropdown
          align="end"
          sideOffset={6}
          menu={{ groups: [{ items }] }}
        >
          <div className="flex items-center justify-center size-5 cursor-pointer">
            <Icons.DotsVertical className="size-5 text-fg-quinary" />
          </div>
        </Dropdown>
      )}
    </div>
  );
};

export default ChatHeader;
